import styled from 'styled-components';
import { Box } from '@components/Box';
import { Text } from '@components/typography';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { TextPairing } from '@components/TextPairing';
import { PlaceholderCloudImage, CloudImage } from '@components/CloudImage';
import { TOP_BANNER_HEIGHT } from '@layout';

export const GuestListHeroSection = styled(Box)`
  padding-top: calc(${themeSpace(4)} + ${TOP_BANNER_HEIGHT}px);
`;

export const StyledTextPairing = styled(TextPairing)`
  ${themeMediaQuery('below_sm')} {
    align-items: center;
  }
  .text-pairing-title {
    max-width: 330px;
    ${themeMediaQuery('below_sm')} {
      text-align: center;
      max-width: 240px;
    }
    ${themeMediaQuery('lg')} {
      max-width: 430px;
      font-size: 56px;
      line-height: 68px;
    }
  }
  .text-pairing-body {
    width: 582px;
    ${themeMediaQuery('below_sm')} {
      display: none;
    }
    ${themeMediaQuery('sm')} {
      width: 480px;
    }
    ${themeMediaQuery('xl')} {
      width: 596px;
    }
  }
`;

export const StyledBox = styled(Box)`
  text-align: center;
`;

export const StyledAvatarsBox = styled(Box)`
  width: 100%;
  position: relative;
  z-index: 1;
  max-width: 1320px;
  margin: auto;
  display: flex;
`;

export const StyledLottieBox = styled(Box)`
  z-index: 2;
  position: relative;
  width: 100%;
  min-height: 39vh;
`;

export const StyledLottieContainerBox = styled(Box)`
  margin: auto;
  display: flex;
  top: -15px;
  width: 60%;
  position: relative;
  z-index: 1;
  ${themeMediaQuery('below_sm')} {
    width: 90%;
  }
`;

export const StyledTextWrapper = styled(Box)<{ isInvite?: boolean }>`
  position: absolute;
  top: 10%;
  z-index: 3;
  left: ${({ isInvite }) => (isInvite ? 60 : 52)}%;
  opacity: 0;
  width: max-content;
  ${themeMediaQuery('below_sm')} {
    top: 5%;
  }
`;

export const StyledText = styled(Text)`
  ${themeMediaQuery('below_sm')} {
    font-size: 20px;
    line-height: 26px;
  }
  ${themeMediaQuery('sm')} {
    font-size: 36px;
    line-height: 40px;
  }
  ${themeMediaQuery('md')} {
    font-size: 48px;
    line-height: 54px;
  }
  ${themeMediaQuery('lg')} {
    font-size: 72px;
    line-height: 88px;
  }
`;

export const StyledIconBox = styled(Box)`
  width: 90px;
  height: 140px;
  margin-right: auto;
  ${themeMediaQuery('below_sm')} {
    width: 45px;
    height: 75px;
  }
  ${themeMediaQuery('sm')} {
    width: 50px;
    height: 75px;
  }
  ${themeMediaQuery('md')} {
    width: 65px;
    height: 105px;
  }
  ${themeMediaQuery('lg')} {
    width: 90px;
    height: 140px;
  }
`;

export const StyledSideBox = styled(Box)`
  top: 80%;
  position: absolute;
  width: 170%;
  left: -35%;
  opacity: 0;
  ${themeMediaQuery('sm')} {
    top: 270%;
  }
  ${themeMediaQuery('md')} {
    top: 190%;
  }
  @media (min-width: 1400px) {
    top: 140%;
  }
  ${themeMediaQuery('lg')} {
    top: 135%;
  }
  ${themeMediaQuery('xl')} {
    top: 83%;
  }
`;

export const StyledSideCloudImage = styled(CloudImage)`
  width: 100vw;
  height: 100vw;
  position: relative;
`;

export const StyledHeroTopBox = styled(Box)<{ isLeft: boolean; top: string; offset: string }>`
  position: absolute;
  transition: all 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
  top: ${({ top }) => top};
  left: ${({ isLeft, offset }) => (isLeft ? offset : 'initial')};
  right: ${({ isLeft, offset }) => (isLeft ? 'initial' : offset)};
`;

export const StyledHeroTopCloudImage = styled(PlaceholderCloudImage)<{ width: number; height: number }>`
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  position: relative;
`;

export const StyledLeftHeroBox = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  ${themeMediaQuery('sm')} {
    left: -20%;
  }
  ${themeMediaQuery('md')} {
    left: 0;
  }
  ${themeMediaQuery('lg')} {
    left: 5%;
  }
  ${themeMediaQuery('xl')} {
    right: 75%;
    left: 0;
  }
`;

export const StyledRightHeroBox = styled(Box)`
  position: absolute;
  top: 0;
  right: 0;
  ${themeMediaQuery('sm')} {
    right: -20%;
  }
  ${themeMediaQuery('md')} {
    right: 0;
  }
  ${themeMediaQuery('lg')} {
    right: 5%;
  }
  ${themeMediaQuery('xl')} {
    left: 75%;
    right: 0;
  }
`;

export const StyledHeroAvatar = styled(Box)<{ top: string; left: string }>`
  position: absolute;
  transition: all 0.4s cubic-bezier(0.075, 0.82, 0.165, 1);
  top: ${({ top }) => top};
`;

export const StyledLeftHeroAvatar = styled(StyledHeroAvatar)<{ top: string; left: string }>`
  left: ${({ left }) => left};
`;

export const StyledRightHeroAvatar = styled(StyledHeroAvatar)<{ top: string; left: string }>`
  right: ${({ left }) => left};
`;
